import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Close } from 'components/icons';
import IconButton from '@mui/material/IconButton';
import MuiSnackbarContent from '@mui/material/SnackbarContent';
import { MessageRoot, Icon } from './style'; // ⬅️ import styled components

const variantIcon = {
  success: null,
  warning: null,
  error: null,
  info: null
};

function SnackbarContent(props) {
  const { className, message, variant, onClose, ...other } = props;
  const VariantIcon = variantIcon[variant];

  return (
    <MuiSnackbarContent
      action={[
        <IconButton color="inherit" key="close" onClick={onClose}>
          <Close className="icon" /> {/* can also wrap in <Icon> if needed */}
        </IconButton>
      ]}
      className={clsx(className)} // external classes if passed
      message={
        <MessageRoot className={variant}>
          {VariantIcon && <Icon as={VariantIcon} className="iconVariant" />}
          {message}
        </MessageRoot>
      }
      {...other}
    />
  );
}

SnackbarContent.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired
};

export default SnackbarContent;
